// extracted by mini-css-extract-plugin
export default {"card":"sCard_card__NF7bH"};